<template>
  <b-card no-body>
    <b-card-header @click="onHeaderClick">
      <slot name="header" />
    </b-card-header>
    <b-collapse ref="collapse" :visible="visible">
      <b-card-body>
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: 'CardCollapsible',

  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onHeaderClick() {
      this.$refs.collapse.toggle()
    }
  }
}
</script>
